<template>

    <!--@todo-->
    <div class="bg-light p-2 mb-3">
        <form class="row row-cols-lg-auto align-items-center">
            <div class="col">
                <label class="visually-hidden" for="inlineFormSelectPref">Preference</label>
                <select class="form-select" id="inlineFormSelectPref">
                    <option selected>Choose...</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>
            </div>
            <div class="col">
                <label class="visually-hidden" for="inlineFormSelectPref1">Preference</label>
                <select class="form-select" id="inlineFormSelectPref1">
                    <option selected>Choose...</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>
            </div>
            <div class="col">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="inlineFormCheck" />
                    <label class="form-check-label" for="inlineFormCheck">
                        Remember me
                    </label>
                </div>
            </div>
            <div class="col">
                <button type="submit" class="btn btn-outline-dark">Apply</button>
            </div>
        </form>
    </div>

</template>

<script>
    export default {
        props: {
            filters: Array,
        },
    }
</script>